/**
 * Configure and register global directives
 */
import type { App } from 'vue'
import { setupLoadingDirective } from './loading'
import { setupDragDirective } from './drag'

export function setupGlobDirectives(app: App) {
  setupLoadingDirective(app)
  setupDragDirective(app)
}
